import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { StringComparer } from "@/shared/helpers/string-comparer";
import MyMotionsStatusViewerComponent from "../my-motions-component/my-motions-status-viewer-component/my-motions-status-viewer-component";
import { friendlyDateTime } from "@/shared/filters";
import { IMyMotionsListEntry } from "@/shared/api-client/models/motion/my-motions-list-entry";
import { ArgumentValidator } from "@/shared/helpers/argument-validator";
import { UIEventHandler } from '@/shared/helpers/ui-event-handler';
import { IMotionProposal } from '@/shared/api-client/models/motion/motion-proposal';
import { ApiClient } from '@/shared/api-client/api-client';
import { ConsoleFacade, NameOf } from '@/shared/helpers';
import { IMotionSchema } from '@/shared/api-client/models/motion/motion-schema';
import { IMotionProperty } from '@/shared/api-client/models/motion/motion-property';

interface IViewModel {
    isInitialized: boolean;
    motionSchema?: IMotionSchema;
}

@Component({
    computed: {
        StringComparer() {
            return StringComparer
        }
    },
    components: {
        MyMotionsStatusViewerComponent
    },
    filters: {
        friendlyDateTime
    }
})
export default class MyMotionsDetailsComponent extends Vue {

    @Prop({ default: 'sv-SE' }) public culture!: string;
    @Prop() public motion!: IMyMotionsListEntry;
    @Prop() public translations!: { [key: string]: string; };
    @Emit('back') public emitBack(): void {}

    public viewModel: IViewModel = {
        isInitialized: false
    };
    private apiClient: ApiClient = new ApiClient();

    public async created() {
        await this.loadScheme();
    }

    public get properties(): IMotionProperty[] {
        return this.viewModel.motionSchema?.properties?.filter(prop => prop.identifier !== 'title') ?? [];
    }

    private async loadScheme(): Promise<void> {

        try {

            const schema = await this.apiClient.motion.schema(this.motion.activityId, this.culture);

            this.$set(this.viewModel, NameOf.property(this.viewModel, x => x.motionSchema), schema);
            this.$set(this.viewModel, NameOf.property(this.viewModel, x => x.isInitialized), true);

        } catch (error) {
            ConsoleFacade.error('Failed to load motion schema', error);
        }
    }


    public printProperty(motion: IMyMotionsListEntry, propertyIdentifier: string, defaultValue = 'N/A'): string {

        ArgumentValidator.notNullOrEmpty(motion, `motion`);
        ArgumentValidator.notNullOrEmpty(propertyIdentifier, `propertyName`);

        return motion.properties.find(prop => prop.identifier === propertyIdentifier)?.value || defaultValue;
    }

    public getProposals(motion: IMyMotionsListEntry, propertyIdentifier: string): IMotionProposal[] {
        return (motion.properties.find(prop => prop.identifier === propertyIdentifier)?.value || []) as IMotionProposal[];
    }

    public async cancel($event: UIEvent): Promise<void> {

        UIEventHandler.preventDefaults($event);

        this.emitBack();
    }
}